import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelper } from 'angular2-jwt';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { AuthProviderService } from 'app/services/auth.provider.service';
import { EnvironmentsService } from 'app/services/enviornment.service';


@Injectable()

export class UserService {

  private SESSION_KEY = 'esp-api-client-session';
  private TOKEN = 'token';
  public jwtHelper: JwtHelper = new JwtHelper();
  private currentSession: BehaviorSubject<any>;
  private userNameSource = new BehaviorSubject('');
  userName = this.userNameSource.asObservable();
  whenNoAccessSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isSuperAdmin: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private http: Http, private envService: EnvironmentsService, private authProvider: AuthProviderService, private router: Router) {
    let session = null;
    try {
      session = JSON.parse(localStorage.getItem(this.SESSION_KEY));
    } catch (e) {
    }
    this.currentSession = new BehaviorSubject(session);
  }

  changeUser(user: string): void {
    this.userNameSource.next(user);
  }

  getCurrentSession(): BehaviorSubject<any> {
    return this.currentSession;
  }

  getUser(): any {
    const session = this.currentSession.getValue();
    return session ? session.user : null;
  }

  getAccessToken(): string | null {
    const session = this.currentSession.getValue();
    return session ? session.access_token : null;
  }

  getRefreshToken(): string | null {
    try {
      const session = JSON.parse(this.currentSession.getValue()._body);
      return session ? session.refresh_token : null;
    }
    catch {
      return null;
    }
  }

  saveCurrentSession(session): void {
    try {
      const parsedBody = JSON.parse(session._body);
      const accessToken = (parsedBody.body && parsedBody.body.access_token) || parsedBody.access_token;
      
      if (!accessToken) {
        console.error('No access token found in session');
        return;
      }
      
      session.user = this.jwtHelper.decodeToken(accessToken);
      localStorage.setItem(this.SESSION_KEY, JSON.stringify(session));
      this.changeUser(session.user.username || session.user.acct || '');
      this.currentSession.next(session);
    } catch (error) {
      console.error('Error saving session');
    }
  }

  saveToken(token: string): void{
    localStorage.setItem(this.TOKEN, token);
  }

  getToken(): string{
    return localStorage.getItem(this.TOKEN);
  }

  clearCurrentSession(): void {
    localStorage.removeItem(this.SESSION_KEY);
    this.currentSession.next(null);
    this.changeUser('');
  }

  redirectToLogin() {
    const redirectUri = window.location.origin + this.envService.config.redirectUri;
    if (this.envService.config.production) {
      window.location.href = `${this.authProvider.getApiUrl()}/authorize?response_type=code&client_id=${this.envService.config.clientId}&state=${this.envService.config.state}&redirect_uri=${redirectUri}`;
    } else {
      window.location.href = `${this.authProvider.getApiUrl()}/authorize?response_type=code&client_id=${this.envService.config.clientId}&state=${this.envService.config.state}&redirect_uri=${redirectUri}&bypass_uri_check=true`;
    }
  }

  logout() {
    const redirectUri = window.location.origin + this.envService.config.redirectUri;
    //this.onLogout();
    window.location.href = `${this.authProvider.getApiLogoutUrl()}?client_id=${this.envService.config.clientId}&redirect_uri=${redirectUri}&state=${this.envService.config.state}`;
  }


  isTokenExpired(token: string) {
    return this.jwtHelper.isTokenExpired(token);
  }

  redirectToHome(): void {
    const redirectUri = window.location.origin + '/';
    window.location.href = `${redirectUri}`;
  }

  getRole() {
    return this.jwtHelper.decodeToken(this.getAccessToken()).provider;
  }

  setFeedBackUser(): void {
    const user = this.getUser();
    if (user) {
      localStorage.setItem('esp-feedback-user', user.username);
      const script = document.createElement('script');
      script.innerHTML = `esp.identify('${user.username}')`;
      document.head.appendChild(script);
    }
  }

  setOnAuthorizationFail(value: boolean) {
    this.whenNoAccessSource.next(value);
  }

  getOnAuthorizationFail(): Observable<boolean> {
    return this.whenNoAccessSource.asObservable();
  }
  setSuperAdmin(value: boolean) {
    this.isSuperAdmin.next(value);
  }

  getSuperAdmin(): Observable<boolean> {
    return this.isSuperAdmin.asObservable();
  }

  onLogout() {
    sessionStorage.removeItem("isNotAuthorized");
    sessionStorage.setItem("isSuperAdmin", 'false');
    this.setSuperAdmin(false);
    this.clearCurrentSession();
  }
}




// WEBPACK FOOTER //
// ./src/app/services/user.service.ts